export default __webpack_public_path__ + "assets/images/237a21cb2f841d663b988b974e625c91.svg";